import { render, staticRenderFns } from "./ClickableListItem.component.vue?vue&type=template&id=ba1a44ce&"
import script from "./ClickableListItem.component.vue?vue&type=script&lang=js&"
export * from "./ClickableListItem.component.vue?vue&type=script&lang=js&"
import style0 from "./ClickableListItem.component.vue?vue&type=style&index=0&id=ba1a44ce&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports